import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { AppBar, IconButton, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import InputIcon from '@mui/icons-material/Input';
import { AppContext } from '@/AppContext';

const PREFIX = 'Topbar';

const classes = {
  root: `${PREFIX}-root`,
  logo: `${PREFIX}-logo`,
  topLabel: `${PREFIX}-topLabel`,
  flexGrow: `${PREFIX}-flexGrow`,
  signOutButton: `${PREFIX}-signOutButton`,
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  [`&.${classes.root}`]: {
    boxShadow: 'none',
    ['@media (min-width: 0px) and (orientation: landscape)']: {
      minHeight: 56,
    },
  },

  [`& .${classes.logo}`]: {
    ['@media (max-width:700px)']: {
      width: 120,
    },
    ['@media (max-width:500px)']: {
      width: 100,
    },
    ['@media (max-width:375px)']: {
      width: 80,
    },
  },

  [`& .${classes.topLabel}`]: {
    position: 'absolute',
    width: '100%',
    textAlign: 'center',
    color: 'inherit',
    ['@media (max-width:700px)']: {
      fontSize: 16,
    },
    ['@media (max-width:500px)']: {
      fontSize: 12,
    },
    ['@media (max-width:375px)']: {
      fontSize: 10,
    },
  },

  [`& .${classes.flexGrow}`]: {
    flexGrow: 1,
  },

  [`& .${classes.signOutButton}`]: {
    marginLeft: theme.spacing(1),
  },
}));

const Topbar = props => {
  const { className, data, ...rest } = props;
  const theme = useTheme();

  const appContext = useContext(AppContext);

  const handleSignOut = event => {
    event.preventDefault();
    appContext.logout();
    // history.push('/');
  };

  return (
    <StyledAppBar {...rest} className={clsx(classes.root, className)} color={theme.appBarColor} position='fixed'>
      <Toolbar>
        <RouterLink to='/reception'>
          <img alt='Logo' src={theme.topLogo} width={theme.topLogoWidth || '100%'} className={classes.logo} />
        </RouterLink>

        <div className={classes.flexGrow} />

        <Typography variant='h4' className={classes.topLabel} data-test-id='top-header'>
          {data.meetup.name} \ {data.deskName}
        </Typography>

        <IconButton className={classes.signOutButton} color='inherit' onClick={handleSignOut} size='large'>
          <InputIcon />
        </IconButton>
      </Toolbar>
    </StyledAppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
};

export default Topbar;
